import { Select, SelectProps } from '@chakra-ui/react';
import { InputVariant } from 'presentation/theme/components/input';
import { FC } from 'react';

const SelectInput: FC<SelectProps> = (props) => {
  return <Select variant={InputVariant.filled} {...props} />;
};

export default SelectInput;
